module.exports = __webpack_public_path__ + "static/media/activity-icon-court-logo.be26c673.svg";